import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LOGO_URL = "https://i.ibb.co/3y7zpmrq/Gemini-Generated-Image-e6u2kle6u2kle6u2-1-1-removebg-preview.png";

const navLinks = [
  { label: "Sobre Nós", href: "#sobre" },
  { label: "Oportunidade", href: "#oportunidade" },
  { label: "Pilares", href: "#pilares" },
  { label: "Serviços", href: "#servicos" },
  { label: "Valores", href: "#valores" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (href) => {
    setMobileOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="header"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/80 backdrop-blur-xl shadow-lg border-b border-slate-100"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a href="#hero" onClick={() => scrollTo("#hero")} data-testid="header-logo-link">
            <img src={LOGO_URL} alt="Duali Soluções" className={`h-16 w-auto transition-all duration-500 ${scrolled ? "" : "brightness-0 invert"}`} />
          </a>

          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                data-testid={`nav-${link.href.slice(1)}`}
                className="text-sm font-semibold text-brand-navy/80 hover:text-brand-teal transition-colors duration-300 tracking-wide"
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => scrollTo("#contato")}
              data-testid="nav-cta-fale-conosco"
              className="bg-brand-teal text-white px-6 py-2.5 rounded-md font-semibold text-sm hover:bg-teal-600 transition-all duration-300 hover:scale-105 hover:shadow-lg"
            >
              Fale Conosco
            </button>
          </nav>

          <button onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden text-brand-navy" data-testid="mobile-menu-toggle">
            {mobileOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {mobileOpen && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white/95 backdrop-blur-xl border-t border-slate-100" data-testid="mobile-nav">
            <div className="px-4 py-6 flex flex-col gap-4">
              {navLinks.map((link) => (
                <button key={link.href} onClick={() => scrollTo(link.href)} className="text-left text-brand-navy font-semibold py-2 border-b border-slate-100">
                  {link.label}
                </button>
              ))}
              <button onClick={() => scrollTo("#contato")} className="bg-brand-teal text-white px-6 py-3 rounded-md font-semibold text-center mt-2">
                Fale Conosco
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
